const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Margot
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot',
    name: 'margot-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Margot',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Margot !<br />Un style néo-classique et sophistiqué. ​Pour un rendu au contraste élevé qui accroche magnifiquement la lumière dans l'empreinte.",
      tags: ['set-tampon-alphabet-margot'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/margot/margot-set-complet.jpg'),
          name: 'Margot',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/set-complet-margot',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/margot/margot-majuscules.jpg'),
          name: 'Margot',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/majuscules-margot',
        },
        {
          src: require('../../../public/img/materiel-creatif/margot/margot-minuscules.jpg'),
          name: 'Margot',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/minuscules-margot',
        },
        {
          src: require('../../../public/img/materiel-creatif/margot/margot-speciaux.jpg'),
          name: 'Margot',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/speciaux-chiffres-margot',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/set-complet-margot',
    name: 'full-set-margot',
    component: () =>
      import('../../pages/products/creative/Margot/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/margot/margot-set-complet.jpg'),
      type: 'Set complet Margot',
      hiddenType: 'margot-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-margot'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/majuscules-margot',
    name: 'uppercase-margot',
    component: () =>
      import('../../pages/products/creative/Margot/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/margot/margot-majuscules.jpg'),
      type: 'Jeu de majuscules Margot',
      hiddenType: 'margot-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-margot'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/minuscules-margot',
    name: 'lowercase-margot',
    component: () =>
      import('../../pages/products/creative/Margot/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/margot/margot-minuscules.jpg'),
      type: 'Jeu de minuscules Margot',
      hiddenType: 'margot-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-margot'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot/speciaux-chiffres-margot',
    name: 'specials-numbers-margot',
    component: () =>
      import('../../pages/products/creative/Margot/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/margot/margot-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Margot',
      hiddenType: 'margot-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-margot'],
    },
  },
];
